module.exports = __webpack_public_path__ + "img/pic2.bc5361d6.jpg";